/**
 * Runtime predicates over the JWT role names. Kept out of `lib/types.ts` so that
 * module stays types-only (erasable at build time). The `Role`/`Tier` types
 * themselves still live in `@/lib/types`.
 */

import type { Tier } from "@/lib/types";

/** Tier derived from a role, or null for platform operators (no org). */
export function tierForRole(role: string): Tier | null {
  if (role.startsWith("agency_")) return "agency";
  if (role.startsWith("client_")) return "client";
  return null;
}

export function isPlatformRole(role: string): boolean {
  return role.startsWith("platform_");
}

export function isAgencyRole(role: string): boolean {
  return role.startsWith("agency_");
}

export function isClientRole(role: string): boolean {
  return role.startsWith("client_");
}

/** True for org ADMIN roles (agency_admin / client_admin), the roles allowed to
 *  manage their org's users. Platform + *_member roles are not admins here. */
export function isOrgAdminRole(role: string): boolean {
  return role === "agency_admin" || role === "client_admin";
}

/** Landing route for a given role. */
export function landingForRole(role: string): string {
  if (isPlatformRole(role)) return "/platform";
  if (isAgencyRole(role)) return "/agency/dashboard";
  return "/dashboard";
}
